import React, { useRef, useState } from 'react';
import { DiktatModul } from '../../lib/diktat-api';
import { UniversaldiktatModal } from './UniversaldiktatModal';
import { MIcon } from '../../lib/micon';
import { mikrofonAnfragen } from '../../lib/mikrofon';

const MODUL_NAME: Record<DiktatModul, string> = {
  fehlzeit:   'Fehlzeit',
  mehrarbeit: 'Mehrarbeit',
  notiz:      'Notiz',
  termin:     'Termin',
  task:       'Aufgabe',
};

interface Props {
  modul: DiktatModul;
  size?: 'sm' | 'md';
  label?: string;
}

export function QuickMicButton({ modul, size = 'md', label }: Props) {
  const [open, setOpen] = useState(false);
  const streamRef = useRef<Promise<MediaStream> | null>(null);

  function handleClick() {
    streamRef.current = mikrofonAnfragen(); // Welle H6: ohne unbehandelte Ablehnung
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
    streamRef.current = null;
  }

  const showLabel = size !== 'sm' && label != null && label !== '';
  const title = `Diktat: ${MODUL_NAME[modul]}`;

  const btnStyle: React.CSSProperties = size === 'sm' ? {
    width: 38,
    height: 38,
    borderRadius: '50%',
    padding: 0,
    border: 'none',
    background: 'var(--ld-primary-light)' as any,
    color: 'var(--ld-primary)' as any,
    fontSize: 18,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  } : {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: showLabel ? 6 : 0,
    padding: '10px 16px',
    borderRadius: 'var(--ld-radius-md)' as any,
    border: 'none',
    background: 'var(--ld-primary)' as any,
    color: 'white',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    whiteSpace: 'nowrap' as const,
  };

  return (
    <>
      <button onClick={handleClick} title={title} style={btnStyle}>
        <MIcon name="mic" size={size === 'sm' ? 20 : 18} />
        {showLabel && <span>{label}</span>}
      </button>
      <UniversaldiktatModal
        open={open}
        onClose={handleClose}
        streamPromise={streamRef.current}
        fixedModul={modul}
      />
    </>
  );
}
